import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronLeft, FiGrid } from "react-icons/fi";
import moment from "moment";

export default function Header({ symbol, updateSymbol }) {
  const navigate = useNavigate();
  const [openType, setOpenType] = useState(false);
  const dropdownRef = useRef(null);
  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenType(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative flex items-center justify-between bg-[var(--background)] px-4 py-3">
      {/* Back Button */}
      <div className="flex-1">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full border-2 border-[var(--hover)] transition"
        >
          <FiChevronLeft className="w-5 h-5 text-[var(--text)]" />
        </button>
      </div>

      {/* Symbol Info */}
      <div className="text-center flex-1">
        <h2 className="text-lg font-bold text-[var(--text)]">
          {symbol.symbol_display || symbol.symbol}
        </h2>
        <p className="text-xs font-semibold text-[var(--text)]">
          {symbol.type === "nse_cash"
            ? "EQUITY"
            : moment(symbol.expiry_date).format("DD-MMM")}
        </p>
      </div>

      {/* Symbol Selector Button */}
      <div className="flex-1 flex justify-end relative" ref={dropdownRef}></div>
    </div>
  );
}
